import React, { useState, useEffect } from 'react';
import 'common/css/master.css';
import { toast } from 'react-toastify';

const ExamPatternCreatorTbl = (props) => {
    const { lstPattern, openSlider, setPatternObj, lstClass, clsId, onClsChange,deletePattern } = props;

    const [lstPatternTbl, setLstPatternTbl] = useState([]);
    const [patternId, setPatternId]         = useState(0);
    const [filterPattern, setFilterPattern] = useState('');

    useEffect(() => {
        setLstPatternTbl(lstPattern);
    }, [lstPattern]);

    function filterByPattern(e) {
        const keyword = e.target.value;
        setFilterPattern(keyword);
        const filtered = lstPattern.filter(p =>
            p.pattern.toLowerCase().includes(keyword.toLowerCase())
        );
        setLstPatternTbl(filtered);
    }

    function setRowPatternId(obj) {
        setPatternId(obj.patternId);
        setPatternObj(obj);
    }

    const colgrp = (
        <colgroup>
            <col width="25%"></col>
            <col width="15%"></col>
            <col width="15%"></col>
            <col width="25%"></col>
            <col width="12%"></col>
            <col width="8%"></col>
        </colgroup>
    );

    return (
        <div style={{ pointerEvents: 'auto' }}>
              {/* Table */}
              {/* Class Dropdown */}
            <div className="col-sm-1 padding-remove" style={{ marginBottom: 10 }}>
              <select
                   className="form-control"
                   value={clsId}
                   onChange={onClsChange}
                  >
        <option value={0}>Class</option>
        {lstClass.map((obj, idx) => (
            <option key={idx} value={obj.clsId}>{obj.cls}</option>
        ))}
    </select>
</div>
            <table className="tableLayout1">
                {colgrp}
                <thead>
                    <tr>
                        <th>
                            <input
                                className="form-control inp-search"
                                placeholder="Pattern Name"
                                value={filterPattern}
                                onChange={filterByPattern}
                            />
                        </th>
                        <th>Max Marks</th>
                        <th>No. of Sections</th>
                        <th>Description</th>
                        <th>Approval Date</th>
                        <th>Action</th>
                    </tr>
                </thead>
            </table>
            <div className="tablebodyWrapper">
                <table className="tableLayout">
                    {colgrp}
                    <tbody>
                        {lstPatternTbl.map((obj, idx) => (
                            <tr
                                key={idx}
                                onClick={() => setRowPatternId(obj)}
                                className={obj.patternId === patternId ? 'selected' : ''}
                            >
                                <td  className='text-left'>{obj.pattern}</td>
                                <td className="text-right">{obj.maxMarks}</td>
                                <td className="text-right">{obj.noOfSections}</td>
                                <td className='text-left'>{obj.patternDesc}</td>
                                <td className="text-center">{obj.approvalDttm || '-'}</td>
                                <td className="text-center">
                                    <span
                                        className="glyphicon glyphicon-edit"
                                        onClick={(e) => { e.stopPropagation(); setRowPatternId(obj); openSlider(); }}
                                        title="Edit"
                                    ></span>

                                    <span
                                    className='glyphicon glyphicon-trash'
                                    onClick={(e)=>{e.stopPropagation(); deletePattern(obj.patternId);}}
                                    title="Delete"
                                    >
                                    </span>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default ExamPatternCreatorTbl;
